import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-edit-tags',
		path: '/admin/p/:slug/edit_tags',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_editTags" */ './index'), {
			exportName: 'EditTags',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: 'staff',
		},
		frame: true,
	},
];
